import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { withRouter } from 'react-router'

import { TIMESERIES_KIND } from '../../constants'
import { defaultOrQueryDate, defaultOrQueryLimit } from '../../utils/QueryParser'
import DatePicker from '../controls/DatePicker'
import TimeseriesChartContainer from './TimeseriesChartContainer'
import TimeseriesHistoryContainer from './TimeseriesHistoryContainer'
import TimeseriesNavContainer from './TimeseriesNavContainer'

class TimeseriesDetailsView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  static styles = () => ({
    picker: {
      alignSelf: 'center',
      textAlign: 'right',
    },
    print: {
      '@media print': {
        display: 'none',
      },
    },
  })

  viewHtml() {
    const { timeseries } = this.props
    if (!timeseries.name) {
      return null
    }

    if (timeseries.kind === TIMESERIES_KIND.STATE || timeseries.kind === TIMESERIES_KIND.OCCURRENCE) {
      const limit = defaultOrQueryLimit(this.props.location.search)
      return <TimeseriesHistoryContainer timeseriesId={this.props.timeseries.id} limit={limit} />
    }

    const [from, to] = defaultOrQueryDate(this.props.location.search)
    return <TimeseriesChartContainer timeseriesId={this.props.timeseries.id} from={from} to={to} />
  }

  render() {
    const { classes, timeseries } = this.props

    if (timeseries.id && timeseries.kind) {
      return (
        <>
          <Grid container className={classes.print}>
            <Grid item xs={12} sm>
              <TimeseriesNavContainer timeseriesId={timeseries.id} />
            </Grid>
            { timeseries.kind === TIMESERIES_KIND.MEASUREMENT
              && (
                <Grid item xs={12} sm className={classes.picker}>
                  <DatePicker />
                </Grid>
              )}
          </Grid>
          {this.viewHtml()}
        </>
      )
    }

    return null
  }
}

export default withStyles(TimeseriesDetailsView.styles)(withRouter(TimeseriesDetailsView))
